module.exports = {"header":"Rilascio %s"};